module.exports = class headerSearch {
  constructor () {
    let bgUrl = $('#bgUrl').val();
    $('.ZCY-rights-center-header-search').css('background', `url(${bgUrl}) center center no-repeat`);
    $('.ZCY-rights-center-header-search').css('background-size', '1920px 500px');
  }
};
